var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import ServiceOfferingService from "../../../../Services/ServiceOffering.service";
import ServiceOfferingForm, { getServiceOfferingRequest, } from "../../../Presentational/ServiceOffering/ServiceOfferingForm";
import { getServiceOfferingsAdminShowPath } from "./AdminServiceOfferingRoutes";
import useService from "../../../Hooks/useService";
import SecondaryNavLayout from "../../../Layout/SecondaryNavLayout";
import SecondaryNavButton from "../../../UI/SecondaryNav/SecondaryNavButton";
import ContentLayout from "../../../Layout/ContentLayout";
import ServiceResult from "../../../UI/ServiceResult/ServiceResult";
import { BasicFormFormat } from "../../../UI/FormFormat/FormFormat";
const ServiceOfferingEdit = () => {
    const saveButtonRef = useRef(null);
    const history = useHistory();
    const [serviceOfferingState, loadServiceOffering] = useService(ServiceOfferingService.get);
    const params = useParams();
    const id = parseInt(params.serviceOfferingId, 10);
    React.useEffect(() => {
        loadServiceOffering(id);
    }, [id, loadServiceOffering]);
    return (_jsx(SecondaryNavLayout, { dontAddSpacer: true, nav: _jsxs("div", { className: "d-flex", children: [_jsx(SecondaryNavButton, { icon: "save", label: "Save", title: "Save", iconType: "fas", onClick: () => {
                        var _a;
                        (_a = saveButtonRef.current) === null || _a === void 0 ? void 0 : _a.click();
                    } }), _jsx(Link, { to: getServiceOfferingsAdminShowPath(id), children: _jsx(SecondaryNavButton, { icon: "times", label: "Cancel", title: "Cancel" }) }, "Cancel")] }), children: _jsxs(ContentLayout, { paddingTop: true, whiteBackground: true, children: [_jsx("div", { className: "title-block", children: _jsx("h1", { className: "title", children: "Edit Service Offering" }) }), _jsx(ServiceResult, { state: serviceOfferingState, children: (serviceOffering) => (_jsx(BasicFormFormat, { saveButtonRef: saveButtonRef, handleSubmit: (formState) => __awaiter(void 0, void 0, void 0, function* () {
                            return ServiceOfferingService.save(getServiceOfferingRequest(formState)).then((response) => {
                                history.push(getServiceOfferingsAdminShowPath(response.id));
                            });
                        }), defaultValue: {
                            id: serviceOffering.id,
                            name: serviceOffering.name,
                            active: serviceOffering.active,
                            isKeyEngagement: serviceOffering.keyEngagement,
                            meetingLength: {
                                label: serviceOffering.meetingLength,
                                value: serviceOffering.meetingLength,
                            },
                            description: serviceOffering.description,
                            hideStaffNames: !serviceOffering.showStaffNames,
                        }, errorMessagePosition: "top", children: _jsx(ServiceOfferingForm, {}) })) })] }) }));
};
export default ServiceOfferingEdit;
